import { formatInTimeZone } from "date-fns-tz";

/**
 * Returns 'M.d (EEE)' in JST
 */
export default function formatMonthDateDay(timestampSeconds: number): string {
  return formatInTimeZone(new Date(timestampSeconds * 1000), 'Asia/Tokyo', 'M.d (EEE)');
}
